// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { application } from "./controllers/application"

import "trix"
import "@rails/actiontext"

// <html> persists across Turbo Drive visits, so Plutonium's color-mode
// controller only computes the dark/light class once, on connect() at the
// first full page load. Re-apply it on every Turbo navigation too.
document.addEventListener("turbo:load", () => {
  const controller = application.getControllerForElementAndIdentifier(
    document.documentElement,
    "color-mode"
  )
  if (controller) controller.applyMode(controller.readMode())
})
